
export const QA_PANEL_ACTIONS = {
	FETCH_QA_LIST: "FETCH_QA_LIST",
	FETCH_QA_LIST_SUCCESS: "FETCH_QA_LIST_SUCCESS",
	FETCH_QA_LIST_ERROR: "FETCH_QA_LIST_ERROR",
	FETCH_QA_LIST_CANCEL: "FETCH_QA_LIST_CANCEL",

	ASSIGN_ACTION_AJAX:"ASSIGN_ACTION_AJAX",
	ASSIGN_ACTION_SUCCESS:"ASSIGN_ACTION_SUCCESS",
	ASSIGN_ACTION_ERROR:"ASSIGN_ACTION_ERROR",
};


export const SUBMISSION_LIST_ACTIONS = {
	FETCH_SUBMISSION_LIST: "FETCH_SUBMISSION_LIST",
	FETCH_SUBMISSION_LIST_SUCCESS: "FETCH_SUBMISSION_LIST_SUCCESS",
	FETCH_SUBMISSION_LIST_ERROR: "FETCH_SUBMISSION_LIST_ERROR",

	CLEAR_SUBMISSION_LIST:"CLEAR_SUBMISSION_LIST",
};

export const QA_REPORT_ACTIONS = {
	FETCH_QA_REPORT: "FETCH_QA_REPORT",
	FETCH_QA_REPORT_SUCCESS: "FETCH_QA_REPORT_SUCCESS",
	FETCH_QA_REPORT_ERROR: "FETCH_QA_REPORT_ERROR",
	RESET_QA_REPORT: "RESET_QA_REPORT",
};
